var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ConversationList',{attrs:{"queryPending":_vm.queryPending,"fetchMorePending":_vm.fetchMorePending},on:{"filtersUpdated":function($event){return _vm.$emit('filtersUpdated')},"fetchMore":function($event){return _vm.$emit('fetchMore')},"toggleDetails":function($event){return _vm.$emit('toggleDetails')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }